import React from 'react'

const ShippingandDelivery = () => {
 const sections = [
  {
    title: "Shipping & Delivery Policy",
    content: (
      <ul style={{ color: "#6C757D", paddingLeft: "20px" }}>

        <li>
          For international orders, shipping is carried through registered international courier 
          companies and/or international speed post.
        </li>

        <li>
          For domestic orders, shipping is carried through registered domestic courier companies 
          and/or speed post.
        </li>

        <li>
          Orders are shipped within 0–7 days, or as per the delivery date agreed during order confirmation, 
          subject to courier/post office norms.
        </li>

        <li>
          BGT Groups is not liable for delays caused by courier/postal authorities and guarantees 
          only to hand over the consignment within the agreed time frame.
        </li>

        <li>
          Delivery will be made to the shipping address provided by the buyer during order placement.
        </li>

        <li>
          Delivery confirmation will be sent to the registered email ID used during registration.
        </li>

        <li>
          For service utilization issues, contact support at  
          <strong> 9866398548</strong> or  
          <strong> infoinryde@gmail.com</strong>
        </li>

      </ul>
    ),
  },
];



  return (
    <div
      style={{
        backgroundColor: "#F8F9FA",
        padding: "100px 20px",
        fontFamily: "'Inter', sans-serif",
        color: "#1C1C1C",
        lineHeight: "1.8",
      }}
    >
      <h1
        style={{
          fontFamily: "'Poppins', sans-serif",
          fontSize: "3rem",
          background: "linear-gradient(90deg, #E63946, #FFC300)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginBottom: "50px",
          textAlign: "center",
        }}
      >
        User Shipping and Driving Policy
      </h1>

      {sections.map((section, index) => (
        <div
          key={index}
          style={{
            backgroundColor: "#FFFFFF",
            padding: "30px",
            borderRadius: "15px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
            marginBottom: "30px",
          }}
        >
          <h2
            style={{
              fontFamily: "'Poppins', sans-serif",
              color: "#E63946",
              paddingBottom: "10px",
              marginBottom: "20px",
            }}
          >
            {section.title}
          </h2>
          {section.content}
        </div>
      ))}
    </div>
  );
}

export default ShippingandDelivery